import { render, staticRenderFns } from "./LoggedIn.vue?vue&type=template&id=2a6ffc58"
import script from "./LoggedIn.vue?vue&type=script&lang=js"
export * from "./LoggedIn.vue?vue&type=script&lang=js"
import style0 from "./LoggedIn.vue?vue&type=style&index=0&id=2a6ffc58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports